import { getCmsEnhancedTripDetailAction } from "../../../Actions/LogicActions/CMSEnhancedTrips/GetCmsEnhancedTripDetailAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { IGetEnhancedTripActionParams } from "../../../Orchestrator/Types/Interface/ICmsEnhancedTrip";

class EnhancedTripDetailInitStep extends StepFlow {
  get stepName() {
    return "EnhancedTripDetailInit_Step";
  }

  async onEventSetup(): Promise<void> {
    this.registerEventSubscription(
      _eventBus.on<IGetEnhancedTripActionParams, void>({
        eventName: evtTree.enhancedTrips.Details.Get,
        handler: async ({ data }) => {
          if (data?.slug) {
            getCmsEnhancedTripDetailAction.setParams(data!);
            getCmsEnhancedTripDetailAction.execute();
          }
        },
      })
    );
  }

  async onExecute(): Promise<void> {
    console.log("Enhanced trip detail Init Step Execute...");
  }
}

export const EnhancedTripDetailInitStepDeclaration = new StepDefinition({
  stepName: "EnhancedTripDetailInit_Step",
  stepClass: EnhancedTripDetailInitStep,
});
